// @ts-strict-ignore
import { type SagaIterator } from 'redux-saga';

import { ReportType } from 'constants/reports/report-type';
import { ApiManager } from 'services/api/api-manager';
import { serializeReportDistribution } from 'services/api/report/v3/filters';
import { type IActionWithPayload } from 'store/helper';

import { staticReportFilters } from '../constants/static-filters';
import {
  type IFetchReportPayload,
  type IReportRequest,
  ReportRequestName,
  RequestVersion,
  type IFetchReportOptions,
} from '../interfaces';

import { makeFetchingSaga } from './helpers';

export function* fetchChatResponseTime(action: IActionWithPayload<string, IFetchReportPayload>): SagaIterator {
  const requests: IReportRequest[] = [
    {
      version: RequestVersion.V3,
      name: ReportRequestName.FirstResponseTime,
      interface: ApiManager.reportApiV3.fetchChatFirstResponseTime,
      extendedFilters: {
        agentResponse: {
          exists: true,
          first: true,
        },
      },
    },
    {
      version: RequestVersion.V3,
      name: ReportRequestName.ResponseTime,
      interface: ApiManager.reportApiV3.fetchChatResponseTime,
      extendedFilters: staticReportFilters[ReportType.ChatResponseTime],
    },
  ];

  const options: IFetchReportOptions = {
    apiFiltersSerializer: serializeReportDistribution,
  };

  yield makeFetchingSaga(ReportType.ChatResponseTime, action, requests, options);
}
